module.exports = __webpack_public_path__ + "img/icon_jam_keluar.1c5dfeb5.svg";